import posthog from 'posthog-js';

const STORAGE_KEY = 'borradh_session_recording_opt_out';

// Signed-in clinic and Borradh staff only. Patients on this app's public routes
// (intake forms, venue, opt-in) are outside these layouts, so they stay off.
const RECORDED_LAYOUTS = ['/_authed', '/_onboarding', '/_admin'];

export function isRecordedRoute(routeIds: string[]): boolean {
  return routeIds.some((routeId) =>
    RECORDED_LAYOUTS.some(
      (layout) => routeId === layout || routeId.startsWith(`${layout}/`)
    )
  );
}

/** On unless someone opts out in Privacy settings. Unreadable storage counts as out. */
export function isSessionRecordingOptedOut(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return true;
  }
}

export function syncSessionRecording(routeIds: string[]) {
  if (!posthog.__loaded) return;
  const shouldRecord =
    isRecordedRoute(routeIds) && !isSessionRecordingOptedOut();
  if (shouldRecord === posthog.sessionRecordingStarted()) return;
  if (shouldRecord) posthog.startSessionRecording();
  else posthog.stopSessionRecording();
}

export function setSessionRecordingOptOut(optOut: boolean) {
  try {
    if (optOut) window.localStorage.setItem(STORAGE_KEY, 'true');
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage is blocked: the choice lasts until this page is reloaded.
  }
  if (!posthog.__loaded) return;
  if (optOut) posthog.stopSessionRecording();
  else posthog.startSessionRecording();
}
